<template>
  <div class="meituanContainer">
    <img class="fzp" src="@/assets/img/meituan/fzp.jpg" />
    <div class="box">
      <div class="top">
        <div class="good">
          <h3>恭喜你</h3>
          <div class="goodName">
            {{ detail.skuName }}
          </div>
        </div>
      </div>
      <div
        class="center"
        v-for="(item, index) in detail.codeList"
        :key="item.id"
      >
        <div class="centerBox">
          <div class="item" v-show="item.cardCode">
            <div class="label">卡号:</div>
            <div class="value">{{ item.cardCode }}</div>
            <div
              class="copy"
              v-clipboard:copy="item.cardCode"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="item" v-show="item.cardPwd">
            <div class="label">卡密:</div>
            <div class="value">{{ item.cardPwd }}</div>
            <div
              class="copy"
              v-clipboard:copy="item.cardPwd"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="item" v-show="item.verifyCode">
            <div class="label">验证码:</div>
            <div class="value">{{ item.verifyCode }}</div>
            <div
              class="copy"
              v-clipboard:copy="item.verifyCode"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="item" v-show="item.shortUrl">
            <div class="label">短链:</div>
            <div class="value">{{ item.shortUrl }}</div>
            <div
              class="copy"
              v-clipboard:copy="item.shortUrl"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="item" v-show="item.redeemCode">
            <div class="label">兑换码:</div>
            <div class="value">{{ item.redeemCode }}</div>
            <div
              class="copy"
              v-clipboard:copy="item.redeemCode"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              复制
            </div>
          </div>
          <div class="item">
            <div class="label">使用说明</div>
            <div class="showRule" @click="showRule(index)">点击展示</div>
          </div>
          <div
            class="rule"
            v-show="index === showRuleIndex"
            v-html="item.useRule"
          />
        </div>
      </div>
      <div class="bottom"></div>
    </div>
    <!-- <div class="rule">
      <h3 class="use"></h3>
      <div>
        1、接收验证码的手机号请填写您本人手机号，兑换前请确保页面所有信息填写正确，兑换后不支持退款！
      </div>
      <div>
        2、如遇订单量大或网络拥堵，券码出库可能会有所延迟，建议您耐心等待，若有疑问可咨询店铺在线客服。
      </div>
      <div>
        3、接收验证码的手机号请填写您本人手机号，兑换前请确保页面所有信息填写正确，兑换后不支持退款！
      </div>
      <div>
        4、如遇订单量大或网络拥堵，券码出库可能会有所延迟，建议您耐心等待，若有疑问可咨询店铺在线客服。
      </div>
    </div> -->
  </div>
</template>

<script>
import { queryVerifyResForH5 } from '@/api/mtH5'
export default {
  name: 'mtH5Detail',
  data() {
    return {
      loading: false,
      showRuleIndex: null,
      detail: {}
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        this.loading = true
        const { data } = await queryVerifyResForH5(this.$route.query)
        this.detail = data
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    showRule(val) {
      if (val === this.showRuleIndex) {
        this.showRuleIndex = null
        return
      }
      this.showRuleIndex = val
    },
    copySuccess() {
      this.$toast({ message: '复制成功!' })
    },
    copyError() {
      this.$toast({ message: '复制失败!' })
    }
  }
}
</script>
<style lang="less" scoped>
.meituanContainer {
  min-height: 100vh;
  // background: #ffea8e url(../../assets/img/meituan/detailbg.jpg) top center
  //   no-repeat;
  background: #ffea8e;
  background-size: 100% 100%;
  overflow: hidden;
  .fzp {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 7777;
  }
  .box {
    // margin: 25px 23px 18px 21px;
    margin: 150px 23px 18px 21px;
    overflow: hidden;
    .top {
      background: url(../../assets/img/meituan/detailTop.png) center no-repeat;
      height: 155px;
      display: flex;
      align-items: center;
      background-size: 100% 100%;
      .good {
        flex: 1;
        text-align: center;
        width: 100%;
        .goodName {
          width: 90%;
          margin: auto;
          font-size: 18px;
          padding-top: 13px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .center {
      background: url(../../assets/img/meituan/detailCenter.png) center repeat;
      padding: 25px 25px 0px 20px;
      box-sizing: border-box;
      background-size: 100% 100%;
      .centerBox {
        background: #ffea8e;
        border-radius: 15px;
        padding: 20px 0 10px;
        .item {
          display: flex;
          align-items: center;
          padding: 0 20px 12px;
          font-size: 12px;
          color: #000000;
          .label {
            width: 50px;
          }
          .value {
            flex: 1;
          }
          .copy {
            width: 48px;
            height: 20px;
            line-height: 20px;
            background: #030001;
            border-radius: 10px;
            font-size: 12px;
            color: #ffffff;
            text-align: center;
          }
          .showRule {
            color: #033cdc;
            text-align: right;
            flex: 1;
          }
        }
        .rule {
          background: #f3f3f5;
          border-radius: 10px;
          margin: 0 14px 0 16px;
          padding: 18px 13px 14px 13px;
          font-size: 12px;
          color: #666666;
          line-height: 20px;
          :deep(img) {
            width: 100% !important;
            height: auto !important;
          }
        }
      }
    }
    .bottom {
      background: url(../../assets/img/meituan/detailBot.png) center repeat;
      background-size: 100% 100%;
      height: 35px;
    }
  }
  // .rule {
  //   padding: 0 35px 0 26px;
  //   font-size: 12px;
  //   color: #000000;
  //   line-height: 20px;
  //   .use {
  //     background: url(../../assets/img/meituan/use.png) center center no-repeat;
  //     background-size: contain;
  //     height: 18px;
  //     margin-bottom: 32px;
  //   }
  //   div {
  //     padding-bottom: 10px;
  //   }
  // }
}
</style>
